import { render, staticRenderFns } from "./FormCertificate.vue?vue&type=template&id=c32e42b0&scoped=true&"
var script = {}
import style0 from "./FormCertificate.vue?vue&type=style&index=0&id=c32e42b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32e42b0",
  null
  
)

export default component.exports